module.exports = __webpack_public_path__ + "media/fonts/Roboto/Roboto-Medium-b14ca2d2b289afceb0b0fcfad933124c.woff";